import i18n from "i18next";
import { TabItem } from "components/Tabs";

export enum TabsValue {
  OVERVIEW = 0,
  INFO = 1,
}
export const tabsData: TabItem<TabsValue>[] = [
  {
    label: i18n.t("overview"),
    value: TabsValue.OVERVIEW,
  },
  {
    label: i18n.t("info"),
    value: TabsValue.INFO,
  },
];
